import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
//import { isString } from 'util';
import { FirebaseService } from '../../../../service/firebase.service';
import { TranslationPipe } from '../../../../shared/pipes/translation.pipe';

@Component({
  selector: 'app-media-registre-display',
  templateUrl: './media-registre-display.component.html',
  styleUrls: ['./media-registre-display.component.scss']
})
export class MediaRegistreDisplayComponent implements OnInit {
  displayData: Array<any> = [];



  keyToRemove: Array<string> = ['langArray', 'name', 'filename', 'id', 'firestoragePath', 'idModule', 'idQuiz']


  constructor(public dialogRef: MatDialogRef<MediaRegistreDisplayComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _firebaseService: FirebaseService, public translation: TranslationPipe) { }

  ngOnInit(): void {
   // console.log(this.data)

    if (this.data.type != 'delete') {
      this._firebaseService.getMedia(this.data.mediaData.id).then(d => {
        if (d.data() != undefined) {
          for (const property in d.data()) {


            if (!this.keyToRemove.includes(property)) {


             // console.log(property, d.data()[property])
              if (d.data()[property].url != undefined && d.data()[property].url.length > 0)
                this.displayData.push({ name: this.translation.transform(property), value: d.data()[property] });
              else if (d.data()[property].url == undefined)
                this.displayData.push({ name: this.translation.transform(property), value: d.data()[property] });
            }
            if (this.data.mediaData.type == 'quiz' && property == 'name') {
              this.displayData.push({ name: this.translation.transform('displayName'), value: d.data()[property] })
            }
          }
        }
        else {

        }


        this.displayData.sort((a, b) => {
          if (a.name > b.name)
            return 1;
          else
            return -1;
        });

        })
    }

  }

  isImage(url) {
    return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
  }

  getUrl(res) {
    let url = null
    if (typeof res === 'string')
      try {
        url = new URL(res);
      }
      catch (err) {

      }


    if (!this.isImage(url))
      url = null;
   return url
  }

}
